var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFailCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "fail_circle") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:none;}.b{stroke:#e2445c;}.c,.d{stroke:none;}.d{fill:#e2445c;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1358 -424)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(1358 424)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M7.5,0A7.5,7.5,0,1,1,0,7.5,7.5,7.5,0,0,1,7.5,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M 7.5 1 C 3.915889739990234 1 1 3.915889739990234 1 7.5 C 1 11.08411026000977 3.915889739990234 14 7.5 14 C 11.08411026000977 14 14 11.08411026000977 14 7.5 C 14 3.915889739990234 11.08411026000977 1 7.5 1 M 7.5 0 C 11.64213943481445 0 15 3.35785961151123 15 7.5 C 15 11.64213943481445 11.64213943481445 15 7.5 15 C 3.35785961151123 15 0 11.64213943481445 0 7.5 C 0 3.35785961151123 3.35785961151123 0 7.5 0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 0.5)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 5,
    y2: 5,
    transform: "translate(1363.5 428.5)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    x2: 5,
    y2: 5,
    transform: "translate(1363.5 428.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailCircle);
export default __webpack_public_path__ + "static/media/fail_circle.cce8f4f0d202a5c65d0ea3a8fe1e8f7a.svg";
export { ForwardRef as ReactComponent };